import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { ObjectDetailsScreenValidationResult } from '../../../../../../../@types/validation-types'
import { Stepper } from '../../../../../../common/inputs/stepper/Stepper'
import LabelWithTooltip from '../../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../common/PopoverContent'

export interface TotalFloorsProps extends FieldProps<ObjectDetailsScreenValidationResult> {
  wrapperClassName?: string
  labelTranslationKey?: string
  popoverLabelTranslationKey?: string
}

export const TotalFloors: React.FC<TotalFloorsProps> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  wrapperClassName = '',
  labelTranslationKey = 'wizard.screen.objectDetails.totalFloors',
  popoverLabelTranslationKey = undefined,
}) => {
  const { t } = useTranslation()

  return (
    <div className={wrapperClassName}>
      <LabelWithTooltip
        inputId='total-floors'
        labelText={t(labelTranslationKey)}
        tooltipContent={
          popoverLabelTranslationKey ? <PopoverContent translationKey={popoverLabelTranslationKey} /> : undefined
        }
        showMandatory={false}
        arrowPosition='left'
        containerClassName='margin-bottom-xs'
      />
      <Stepper
        id='total-floors'
        propertyName='totalFloorsNumber'
        placeholder={t('wizard.screen.objectDetails.placeholder.amount')}
        input={insertionData.totalFloorsNumber}
        type='tel'
        max={999}
        step={1}
        errors={validationMessages?.totalFloorsNumber ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
